"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgentApiDeleteConversation = useAgentApiDeleteConversation;
// src/apis/agent-api/hooks/useDeleteConversation.ts
const recoil_1 = require("recoil");
const shared_1 = require("@heartcheck/shared");
const state_1 = require("../state");
const deleteConversationQuery = new shared_1.GraphqlQuery(
/* GraphQL */ `
    mutation DeleteConversation($id: ID!) {
      deleteConversation(id: $id) {
        id
      }
    }
  `, 
// ✅ Use Cognito User Pools (ID token) via your /graphql proxy
{ forwardAuthMode: "userpools" });
function useAgentApiDeleteConversation() {
    const setConversationsValue = (0, recoil_1.useSetRecoilState)(state_1.Conversations);
    return async (id) => {
        if (!id || typeof id !== "string") {
            // eslint-disable-next-line no-console
            console.error("❌ No valid conversation ID provided for deletion.");
            return;
        }
        try {
            const res = await deleteConversationQuery.invoke({ id });
            if (!res?.deleteConversation?.id) {
                throw new Error("Delete mutation did not return an ID.");
            }
            // Mark state as unloaded so the list hook fetches fresh data.
            setConversationsValue(state_1.Loadable.unloaded());
            // eslint-disable-next-line no-console
            console.log(`✅ Conversation deleted: ${res.deleteConversation.id}`);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error("❌ Failed to delete conversation:", err);
            // Keep state as-is; caller UI can decide how to present the error.
        }
    };
}
